import React from 'react'
import { Chip } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { AccessTime, OfflineBolt } from '@mui/icons-material'
import {
  TimeChip as TimeChipType,
  TimeChipVariant,
} from '../../types/heroTextSection'

interface Props {
  chip: TimeChipType | Pick<TimeChipType, 'time'>
}

const TimeChip: React.FC<Props> = ({ chip }) => {
  const { classes, cx } = useStyles()
  const isHighlighted =
    'variant' in chip && chip.variant === TimeChipVariant.Highlighted

  return (
    <Chip
      classes={{
        icon: cx({
          [classes.icon]: true,
          [classes.iconHighlighted]: isHighlighted,
        }),
        label: classes.label,
        root: cx({
          [classes.root]: true,
          [classes.rootHighlighted]: isHighlighted,
        }),
      }}
      icon={
        isHighlighted ? <OfflineBolt viewBox="2 2 20 20" /> : <AccessTime />
      }
      label={chip.time}
    />
  )
}

const useStyles = makeStyles()((theme) => ({
  icon: {
    borderRadius: '100%',
    color: 'inherit',
    height: '1.25rem',
    marginLeft: '.5rem',
    width: '1.25rem',
  },
  iconHighlighted: {
    boxShadow: '0px 0px 0 2px rgba(215,111,49,0.2)',
    height: '.8rem',
    width: '.8rem',
  },
  label: {
    fontSize: '.88rem',
    lineHeight: 1,
  },
  root: {
    border: `1px solid ${theme.palette.text.primary}`,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.secondary,
    height: '1.75rem',
  },
  rootHighlighted: {
    borderColor: 'currentColor',
    color: theme.colors.orange.a100,
  },
}))

export default TimeChip
